export type ErrorLevel = 'debug' | 'log' | 'error' | 'warning' | 'fatal' | 'info';

export type ErrorBreadcrumb = {
    category?: string;
    data?: { [key: string]: any };
    level?: ErrorLevel;
    message: string;
};

export type ErrorReqContext = {
    user?: {
        id: string;
        ipAddress?: string;
    };
    tags?: { [key: string]: string | number | boolean };
    context?: { [key: string]: unknown };
};

export interface ErrorReporter {
    /**
     * Records a new breadcrumb which will be attached to future events.
     *
     * Breadcrumbs will be added to subsequent events to provide more context on user's actions prior to an error or crash.
     */
    addBreadcrumb: (breadcrumb: ErrorBreadcrumb) => void;

    captureException: (
        err: Error & { stateContext?: any },
        reqContext?: ErrorReqContext,
        extraContext?: { [key: string]: any },
    ) => Promise<void>;

    /** Set context for future error reports. */
    setErrorContext?: (context: ErrorReqContext) => void;
}

export const mockErrorReporter: ErrorReporter = {
    addBreadcrumb: () => undefined,
    captureException: async () => undefined,
    setErrorContext: () => undefined,
};
